export default __webpack_public_path__ + "static/media/8401 - Allo.ce02849e.jpeg";